import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';

import {Principal} from 'src/app/core';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';

import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {CountryMySuffixService} from './country-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-country-my-suffix',
    templateUrl: './country-my-suffix.component.html'
})
export class CountryMySuffixComponent implements OnInit, OnDestroy {
    currentAccount: any;
    countries: ICountryMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    constructor(
        private countryService: CountryMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
        });
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) { 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    loadAll() {
        this.countryService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<ICountryMySuffix[]>) => this.paginateCountries(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/country-my-suffix'], {
            queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/country-my-suffix',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }

    ngOnInit() {
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
        });
        this.registerChangeInCountries();
    }

    ngOnDestroy() {
        if (this.eventSubscriber) 
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: ICountryMySuffix) {
        return item.id;
    }

    registerChangeInCountries() {
        this.eventSubscriber = this.eventManager.subscribe('countryListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateCountries(data: ICountryMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.countries = data;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }
}
